import styled, { css } from 'styled-components';

const disableSelectHighlight = css`
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
`;

const globalStyle = css`
  // common default props for all elements
  * {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    vertical-align: middle !important; // remove strange lower margin from elements
  }

  *:not(input) {
    ${disableSelectHighlight}
    color: white;
  }

  input {
    border: none;
    border-radius: 2px;
    min-width: 10px;
    color: white;   
    box-sizing: border-box;
  }
  input:not([type=range]) {
    background-color: #444444;
  }

  input:disabled {
    background-color: transparent;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  select {
    border-color: transparent;
    background-color: #444444;
  }

  *:focus {
    outline: none;
  }

  button {
    border-color: transparent;
    border-radius: 4px;
    background-color: #00000040;
    cursor: pointer;
  }
  button:hover {
    background-color: #00000080;
  }
`;

export const AppStyled = styled.div`
  ${globalStyle}

  width: 100%;
  height: 100%;

  #RenderArea {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: all;
  }

  #QuickOpen {
    pointer-events: none;
    margin: 0;
    padding: 0;
    font-size: 30px;
    text-align: right;
    text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;  
    position: absolute;
    right: 22px;
    top: 50px;
    background-color: #000000aa;
    border-radius: 5px;
    padding: 5px 60px 5px 5px;
    max-width: 75%;

    > span {
      position: absolute;
      right: 27px;
      top: 7px;
      transform: scale(2, 2) rotate(90deg);
    }
  }
  
  #QuickInstructions {
    pointer-events: none;
    margin: 0;
    padding: 0;
    font-size: 30px;
    text-align: center;
    text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;  
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #000000aa;
    border-radius: 5px;
    padding: 5px;
    max-width: 75%;
  }
`;

export const TitleBarStyled = styled.div<{interacting: boolean}>`
  margin-left: 10px;
  width: calc(100% - 27px);
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  ${({interacting}) => interacting ? css`opacity: 50%;` : ''}

  > span {
    font-size: 30px;
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0px;
    overflow: hidden;
    text-shadow:
      -1px -1px 0 #000,
      1px -1px 0 #000,
      -1px 1px 0 #000,
      1px 1px 0 #000;  
  }

  > input {
    width: 300px;
    ${({interacting}) => interacting ? '' : css`pointer-events: all;`}
  }

  > .FAButton {
    margin: 0px 5px;
    background-color: #00000020;
    ${({interacting}) => interacting ? '' : css`pointer-events: all;`}
  }

`;